import { render, staticRenderFns } from "./reviews-summary.vue?vue&type=template&id=31b63be0&scoped=true"
import script from "./reviews-summary.vue?vue&type=script&lang=js"
export * from "./reviews-summary.vue?vue&type=script&lang=js"
import style0 from "./reviews-summary.vue?vue&type=style&index=0&id=31b63be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b63be0",
  null
  
)

export default component.exports